var React = require('react');

function MenuIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon_Menu","data-name":"Icon/Menu","transform":"translate(1 1)","opacity":"0.702"},[React.createElement("path",{"id":"Line","d":"M0,.4H6.545","transform":"translate(0 9.418)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"2","key":0}),React.createElement("path",{"id":"Line_Copy","data-name":"Line Copy","d":"M0,.4H10.473","transform":"translate(0 4.509)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"2","key":1}),React.createElement("path",{"id":"Line_Copy_2","data-name":"Line Copy 2","d":"M0,.4H13.091","transform":"translate(0 -0.4)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"2","key":2})]));
}

MenuIcon.defaultProps = {"width":"15.091","height":"11.818","viewBox":"0 0 15.091 11.818"};

module.exports = MenuIcon;

MenuIcon.default = MenuIcon;
